import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from "owa-bundling";
import { getRepromptStore } from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "RepromptDialog" */ "./lazyIndex"), { name: "RepromptDialog" });

export const lazyShowRepromptDialogIfRequired: LazyAction<typeof lazyIndex.showRepromptDialogIfRequired, typeof lazyModule> = new LazyAction(lazyModule, m => m.showRepromptDialogIfRequired);

export const RepromptDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.RepromptDialog, undefined, undefined, {
    onlyImportIf: () => getRepromptStore().showPrivacyRepromptDialog,
});

export const RepromptDialogV2: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.RepromptDialogV2, undefined, undefined, {
    onlyImportIf: () => {
        const store = getRepromptStore();
        return (store.showPrivacyRepromptDialog ||
            (store.showSettingsMigrationDialog && !!store.settingsMigrationDataSource));
    },
});
